import React from "react";

const UTR_LENGTH = 12;
// POST /player/deposit `screenshot`: PNG, JPG, JPEG, WEBP or PDF
export const RECEIPT_TYPES = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/webp",
  "application/pdf",
];

/** Keeps only digits, at most 12 (the API's utr_reference length). */
export const sanitizeUtr = (value) =>
  String(value || "")
    .replace(/\D/g, "")
    .slice(0, UTR_LENGTH);

export const isValidUtr = (value) => /^\d{12}$/.test(value);

export const isValidReceipt = (file) =>
  !file || RECEIPT_TYPES.includes(file.type);

/** UTR input plus the optional payment receipt, shared by the UPI and IMPS steps. */
export default function UtrReceiptFields({
  referenceNumber,
  onReferenceChange,
  redBorder,
  receipt,
  onReceiptChange,
  labelId,
}) {
  const showUtrError = referenceNumber.length > 0 && !isValidUtr(referenceNumber);

  return (
    <>
      <label className="text--medium text--light mb-2 mt-4" id={labelId}>
        Enter the Transaction Reference Number(UTR){" "}
        <span aria-hidden="true" className="required-asterisk">
          *
        </span>
      </label>
      <div className="trn-utr mb-2" style={{ paddingRight: "1rem" }}>
        <input
          type="text"
          inputMode="numeric"
          autoComplete="off"
          placeholder="123456789123"
          maxLength={UTR_LENGTH}
          value={referenceNumber}
          className={redBorder ? "red-border form-control" : "form-control"}
          required
          onChange={(e) => onReferenceChange(sanitizeUtr(e.target.value))}
        />
      </div>
      {showUtrError ? (
        <p
          className="text--medium"
          style={{ color: "#FF5252", paddingRight: "1rem" }}
        >
          UTR must be 12 digits
        </p>
      ) : null}

      <div className="document-upload-section mb-3" style={{ paddingRight: "1rem" }}>
        <label className="text--medium text--light mb-2 mt-2">
          Payment receipt (PNG, JPG, WEBP or PDF) (optional)
        </label>
        <div className="file-input-div">
          <span className="text--medium text--light">
            {receipt ? receipt.name : "Choose file"}
          </span>
          <input
            className="file"
            type="file"
            accept=".png,.jpg,.jpeg,.webp,.pdf,image/png,image/jpeg,image/webp,application/pdf"
            onChange={(e) => onReceiptChange(e.target.files?.[0] || null)}
          />
        </div>
        {!isValidReceipt(receipt) ? (
          <p className="text--medium mb-0 mt-1" style={{ color: "#FF5252" }}>
            Receipt must be a PNG, JPG, WEBP or PDF file
          </p>
        ) : null}
      </div>
    </>
  );
}
